import { render, staticRenderFns } from "./TxRenderedPdfs.vue?vue&type=template&id=3bab828e&scoped=true&"
import script from "./TxRenderedPdfs.vue?vue&type=script&lang=js&"
export * from "./TxRenderedPdfs.vue?vue&type=script&lang=js&"
import style0 from "./TxRenderedPdfs.vue?vue&type=style&index=0&id=3bab828e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab828e",
  null
  
)

export default component.exports